<template>
    <section style="margin: 18px;">
        <v-data-table :headers="headers" 
                      :items="TrainerCourse" 
                      hide-actions
                      style="margin-bottom: 10px;"
                        class="elevation-1" 
                        disable-initial-sort>
            <template v-slot:headers="props">
                <tr>
                    <th v-for="header in props.headers" :key="header.text"> {{ header.text }}</th>
                </tr>
            </template>
            <template v-slot:items="props">
                <tr>
                    <td class="text-xs-center">
                        <v-flex>{{ props.item.Name }}</v-flex>
                        <v-flex>{{ props.item.Email }}</v-flex>
                    </td>
                    <td class="text-xs-center">{{ props.item.Course_Name }}</td>
                    <td class="text-xs-center">
                        <v-flex style="height: 108px;overflow: auto;" v-html="props.item.Course_Description"></v-flex>
                    </td>
                    <td class="text-xs-center">
                        <video loop controls :src="props.item.Course_Video" style="width: 200px;height: 110px;" ></video>
                    </td>
                    <td class="text-xs-center">{{ props.item.Approved ? "Approved" : "Not Approved" }}</td>
                    <td class="text-xs-center">
                        <v-btn color="primary" v-if="!props.item.Approved" icon class="btnAction"  @click="ApproveTrainerCourse(props.item,`Approve`)">
                            <v-icon>thumb_up</v-icon>
                        </v-btn>
                        <v-btn color="error" v-else icon class="btnAction" @click="ApproveTrainerCourse(props.item,`Decline`)">
                            <v-icon>thumb_down</v-icon>
                        </v-btn>
                    </td>
                </tr>
            </template>
        </v-data-table>
        <pagination v-model="pages" :records="records" :per-page="10" @paginate="GetNextSetOfData"></pagination>
    </section>
</template>
<script>
export default {
    data(){
        return {
            TrainerCourse   : [],
            headers : [ { text: 'Trainer Name' ,value: 'Name'},
                        { text: 'Course Name' ,value: 'Course_Name'},
                        { text: 'Course Description' ,value: 'Course_Description'},
                        { text: 'Course Video' ,value: 'Course_Video'},
                        { text: 'Approved' , value:'Approved' },
                        { text: 'Actions' } ],
            pages       : 1,
            records     : 0
        }
    },
    methods:{
        GetNextSetOfData(data){


            this.$http.post(`${this.$store.getters.GetProductionUrl}/trainer/gettrainercourselist`,data)
                .then(response => {
                    
                    this.TrainerCourse = response['data']['response']
                    this.records = response['data']['Records']
                    this.$eventHub.$emit("LOADING",'false')
                })
                .catch(err => {
                    this.$eventHub.$emit("LOADING",'false')
                    this.$eventHub.$emit("SNACK_BAR", { Show: true,Text: "Error While Fetching Data",Color: "red",Close: false});
                });
        },
        ApproveTrainerCourse(TrainerCourse,Status){

            let data = { 'Course_Id'   : TrainerCourse['_id'] , 'limit' : 10, 'page' : this.pages}
            data['Update'] = { 'Approved'     : Status == 'Approve' ? true : false }
            this.$http.post(`${this.$store.getters.GetProductionUrl}/trainer/approvetrainercourse`,data)
                    .then(response => {
                        
                        this.TrainerCourse = response['data']['response']
                        this.records = response['data']['Records']
                        this.$eventHub.$emit("SNACK_BAR", { Show: true,Text: "Successfully Approved Trainer",Color: "green",Close: false});
                    })
                    .catch(err => {

                        this.$eventHub.$emit("SNACK_BAR", { Show: true,Text: "Failed To Approve Trainer",Color: "red",Close: false});
                    });
        }
    },
    mounted(){

        this.GetNextSetOfData({ 'limit' : 10, 'page' : this.pages })
    }
}
</script>
<style>
.clsForActions{
    margin: 2px;
    padding: 2px;
    border: 1px solid #0000003d;
    border-radius: 2px;
    cursor: pointer;
}
.VuePagination ul{
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    padding-left: 0;
    list-style: none;
    border-radius: 0.25rem;
 }
.VuePagination li{
    border: 1px solid #887a7a0f !important;
 }
 .pagination {
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    padding-left: 0;
    list-style: none;
    border-radius: 0.25rem;
}
.page-link {
    position: relative;
    display: block;
    padding: 0.5rem 0.75rem;
    margin-left: -1px;
    line-height: 1.25;
    color: #007bff;
    background-color: #fff;
    border: 1px solid #dee2e6;
    text-decoration: none;
}
.VuePagination__count {
    font-size: 12px;
    font-weight: bold;
    text-align: right;
    text-transform: capitalize;
}
</style>